import { AMENITIES } from "../../lib/data";

/**
 * Amenities — light editorial bento grid.
 * Status badges show 'Coming by December' / 'Coming Soon' / 'Operational'.
 */
export default function Amenities() {
  return (
    <section
      id="amenities"
      data-testid="amenities-section"
      className="relative bg-[#EBE7DF] text-[#1A362D] py-20 md:py-32 overflow-hidden"
    >
      <div className="relative max-w-[100rem] mx-auto px-6 sm:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14 md:mb-20 items-end">
          <h2 className="reveal lg:col-span-7 font-serif-display text-[2.5rem] sm:text-5xl md:text-6xl lg:text-7xl leading-[0.95] tracking-tight font-light">
            Seven amenities.
            <br />
            <em className="font-normal">One lifetime membership.</em>
          </h2>
          <p className="reveal lg:col-span-5 text-[#3A453B] text-base md:text-lg leading-relaxed max-w-md">
            Every plot owner gets lifetime access. Transferred with the title.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 lg:auto-rows-[260px] gap-3 lg:gap-4">
          {AMENITIES.map((a, idx) => (
            <article
              key={a.id}
              data-testid={`amenity-${a.id}`}
              className={`reveal relative overflow-hidden bg-[#1A362D]/10 group h-[260px] sm:h-[300px] lg:h-auto ${a.span}`}
              style={{ transitionDelay: `${idx * 80}ms` }}
            >
              <img
                src={a.image}
                alt={a.title}
                className="absolute inset-0 w-full h-full object-cover transition-all duration-[1500ms] ease-out group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A130F]/85 via-[#0A130F]/35 to-transparent" />

              {a.status === "Operational" ? (
                <span
                  data-testid={`amenity-status-${a.id}`}
                  className="absolute top-4 left-4 px-3 py-1 bg-[#E2CFA1] text-[#1A362D] text-[9px] tracking-[0.28em] uppercase font-semibold"
                >
                  Operational
                </span>
              ) : (
                <span
                  data-testid={`amenity-status-${a.id}`}
                  className="absolute top-4 left-4 px-3 py-1 border border-[#F7F5F0]/70 bg-[#0A0F0C]/40 backdrop-blur-sm text-[#F7F5F0] text-[9px] tracking-[0.28em] uppercase font-medium"
                >
                  {a.status}
                </span>
              )}

              <div className="relative z-10 h-full flex flex-col justify-end p-6 lg:p-7">
                <h3 className="font-serif-display text-2xl sm:text-3xl md:text-4xl text-[#F7F5F0] leading-tight font-light">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm text-[#F7F5F0]/85 tracking-wide">
                  {a.line}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
